export const LOAN_CATEGORIES = {
  EXISTING: 'Existing',
  INPROGRESS: 'InProgress',
  OPPORTUNITY: 'Opportunity',
  PREVIOUS: 'Previous',
};
